import { redirect } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Signout() {
  localStorage.removeItem("token");
  window.location.href = "/";
}

export default Signout;
